(function () {
  'use strict';

  function initFaqAccordions() {
    document.querySelectorAll('.faq-section .faq-list').forEach(function (list) {
      list.querySelectorAll('.faq-q').forEach(function (button) {
        if (button.dataset.gear3FaqBound === 'true') return;
        button.dataset.gear3FaqBound = 'true';

        button.addEventListener('click', function () {
          var item = button.closest('.faq-item');
          if (!item) return;
          var isOpen = item.classList.contains('open');
          list.querySelectorAll('.faq-item.open').forEach(function (openItem) {
            openItem.classList.remove('open');
          });
          if (!isOpen) item.classList.add('open');
        });
      });
    });
  }

  function initStickyBar() {
    var pageRoot = document.querySelector('.gear-3-page');
    var sticky = document.querySelector('.bb-sticky-bottom');
    var hero =
      (pageRoot && pageRoot.querySelector('.bb-hero')) || document.querySelector('.bb-hero');

    if (!sticky || !hero) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('bb-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0.05 }
    );
    observer.observe(hero);
  }

  function init() {
    initFaqAccordions();
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
